import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getPortListNoPerm } from "app/services/apis/ListApi/portListNoPerm";
import { downloadShipmentWeightReport, downloadShopShipmentWeightReport } from "app/services/apis/ReportApis/Dispatch/ShipmentWeightReport";
import { getSalesPersonList } from "app/services/apis/salesPersonDropdown";
import { dateFun } from "app/utils/constants/functions";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

const showSwal = (options) =>
  Swal.fire({
    ...options,
    didOpen: () => {
      const container = document.querySelector(".swal2-container");
      if (container) {
        container.style.zIndex = "20000";
      }
    },
  });

// const DATE_TYPES = [
//   { label: "Order Date", value: "order_date" },
//   { label: "Expected Delivery Date", value: "expected_delivery_date" },
//   { label: "Delivered Date", value: "delivered_date" },
// ];

const TRANSPORT_TYPES = ["Hand", "Air", "Sea", "DHL"];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 15 }, (_, i) => String(currentYear - i));
const MONTHS = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const pickerSx = {
  width: "100%",
  "& .MuiInputBase-root": {
    height: "39px",
    flexDirection: "unset",
  },
};

// const parsePort = (value) => {
//   const text = String(value || "");
//   const dashIndex = text.indexOf("-");
//   if (dashIndex === -1) {
//     return { port_no: text, port_name: "" };
//   }
//   return {
//     port_no: text.slice(0, dashIndex),
//     port_name: text.slice(dashIndex + 1),
//   };
// };

const ShipmentWeightReportModal = ({ open, onClose, isShopOrder = false }) => {
  const [inputs, setInputs] = useState({});
  const [portList, setPortList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      const [ports, salesPersons] = await Promise.all([
        getPortListNoPerm(),
        getSalesPersonList(),
      ]);
      setPortList(ports || []);
      setSalesPersonList(
        (salesPersons || []).filter((person) =>
          /^\d+$/.test(String(person?.id ?? "").trim())
        )
      );
    };
    load();
  }, [open]);

  // const parsedPorts = useMemo(
  //   () => (portList || []).map(parsePort).filter((item) => item.port_no),
  //   [portList]
  // );

  // const portNoOptions = useMemo(
  //   () => [...new Set(parsedPorts.map((item) => item.port_no))],
  //   [parsedPorts]
  // );

  // const portNameOptions = useMemo(() => {
  //   const filtered = inputs.port_no_from
  //     ? parsedPorts.filter((item) => item.port_no === inputs.port_no_from)
  //     : parsedPorts;
  //   return [...new Set(filtered.map((item) => item.port_name).filter(Boolean))];
  // }, [parsedPorts, inputs.port_no_from]);

  const resetForm = () => {
    setInputs({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleGenerate = async () => {
    if ((inputs.dispatch_est_delivery_date_from && !inputs.dispatch_est_delivery_date_to) || (!inputs.dispatch_est_delivery_date_from && inputs.dispatch_est_delivery_date_to)) {
      return showSwal({ icon: "warning", title: "Select From and To Date" });
    }
    if (inputs.dispatch_est_delivery_date_from && inputs.dispatch_est_delivery_date_to && inputs.dispatch_est_delivery_date_from > inputs.dispatch_est_delivery_date_to) {
      return showSwal({ icon: "warning", title: "From Date cannot be greater than To Date" });
    }
    if (inputs.month && !inputs.year) {
      return showSwal({ icon: "warning", title: "Select Year" });
    }

    try {
      setLoading(true);
      const data = isShopOrder
        ? await downloadShopShipmentWeightReport(inputs)
        : await downloadShipmentWeightReport(inputs);
      if (data) {
        window.open(data, "_blank");
        handleClose();
      } else {
        showSwal({ icon: "error", title: "No Result Found" });
      }
    } catch (error) {
      showSwal({
        icon: "error",
        title: error?.response?.data?.message || "No Result Found",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: "700" }}>
        Shipment Weight Report
      </DialogTitle>
      <DialogContent>
        <Div sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
          {/* <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Filter Date Type</Typography>
            <Select
              size="small"
              sx={{ width: "100%" }}
              value={inputs.filter_date_type || "delivered_date"}
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  filter_date_type: e.target.value,
                }))
              }
            >
              {DATE_TYPES.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </Div> */}
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">From Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YY"
                value={inputs.dispatch_est_delivery_date_from ? dayjs(inputs.dispatch_est_delivery_date_from) : null}
                onChange={(newDate) =>
                  setInputs((prev) => ({
                    ...prev,
                    dispatch_est_delivery_date_from: newDate ? dateFun(newDate) : "",
                    // order_item_est_delivery_date_from: newDate ? dateFun(newDate) : "",
                    // date_from: newDate ? dateFun(newDate) : "",
                  }))
                }
                sx={pickerSx}
              />
            </LocalizationProvider>
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">To Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YY"
                value={inputs.dispatch_est_delivery_date_to ? dayjs(inputs.dispatch_est_delivery_date_to) : null}
                onChange={(newDate) =>
                  setInputs((prev) => ({
                    ...prev,
                    dispatch_est_delivery_date_to: newDate ? dateFun(newDate) : "",
                    // order_item_est_delivery_date_to: newDate ? dateFun(newDate) : "",
                    // date_to: newDate ? dateFun(newDate) : "",
                  }))
                }
                sx={pickerSx}
              />
            </LocalizationProvider>
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Month</Typography>
            <Select
              size="small"
              sx={{ width: "100%" }}
              value={inputs.month || ""}
              displayEmpty
              onChange={(e) =>
                setInputs((prev) => ({ ...prev, month: e.target.value }))
              }
            >
              <MenuItem value="">Select</MenuItem>
              {MONTHS.map((month) => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Year</Typography>
            <Select
              size="small"
              sx={{ width: "100%" }}
              value={inputs.year || ""}
              displayEmpty
              onChange={(e) =>
                setInputs((prev) => ({ ...prev, year: e.target.value }))
              }
            >
              <MenuItem value="">Select</MenuItem>
              {YEARS.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Port No - Port Name</Typography>
            <Autocomplete
              size="small"
              options={portList || []}
              value={inputs.port_no_and_name || null}
              onChange={(e, newValue) =>
                setInputs((prev) => ({
                  ...prev,
                  port_no_and_name: newValue || "",
                }))
              }
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Div>
          {/* <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Port No From</Typography>
            <Autocomplete
              size="small"
              options={portNoOptions}
              value={inputs.port_no_from || null}
              onChange={(e, newValue) => {
                const matched = parsedPorts.find(
                  (item) => item.port_no === newValue
                );
                setInputs((prev) => ({
                  ...prev,
                  port_no_from: newValue || "",
                  port_name: matched?.port_name || "",
                }));
              }}
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Port Name</Typography>
            <Autocomplete
              size="small"
              options={portNameOptions}
              value={inputs.port_name || null}
              onChange={(e, newValue) =>
                setInputs((prev) => ({
                  ...prev,
                  port_name: newValue || "",
                }))
              }
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  {option}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Div> */}
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Transport Type</Typography>
            <Select
              size="small"
              sx={{ width: "100%" }}
              value={inputs.transport_type || ""}
              displayEmpty
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  transport_type: e.target.value,
                }))
              }
            >
              <MenuItem value="">Select</MenuItem>
              {TRANSPORT_TYPES.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </Div>
          <Div sx={{ width: "31%" }}>
            <Typography variant="h5">Sales Person Name</Typography>
            <Autocomplete
              size="small"
              options={salesPersonList || []}
              value={inputs.sales_person || null}
              getOptionLabel={(option) => {
                if (option instanceof Object && !Array.isArray(option)) {
                  return option?.full_name || "";
                }
                return option || "";
              }}
              isOptionEqualToValue={(option, value) =>
                String(option?.id) === String(value?.id)
              }
              onChange={(e, newValue) =>
                setInputs((prev) => ({
                  ...prev,
                  sales_person: newValue || null,
                  salesman_id: newValue?.id || "",
                  salesman_name: newValue?.full_name || "",
                }))
              }
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  {option?.full_name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Div>
        </Div>
      </DialogContent>
      <DialogActions>
        <Button onClick={resetForm} color="primary" variant="outlined">
          Clear
        </Button>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
        <Button
          variant="contained"
          onClick={handleGenerate}
          disabled={loading}
        >
          Generate Report
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShipmentWeightReportModal;
